import { useState } from "react";
import { Moon, Sun } from "lucide-react";

export const ThemeToggle = ({ className = "" }) => {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("bpbd_dark", next ? "1" : "0");
  };
  return (
    <button
      onClick={toggle}
      aria-label={dark ? "Mode terang" : "Mode gelap"}
      title={dark ? "Mode terang" : "Mode gelap"}
      data-testid="dark-mode-toggle"
      className={`btn-pop w-9 h-9 rounded-full border border-slate-300 dark:border-slate-600 flex items-center justify-center text-slate-600 hover:text-orange-600 hover:border-orange-400 transition-colors ${className}`}
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};
